import {useGoogleReCaptcha} from 'react-google-recaptcha-v3'
import { Link } from "wouter"
import axios from "axios"
import {useState} from "react"
import appConfig from "../service/config"
import getErrorMessage from "../service/getError";
import Spinner from "./Spinner";
import FacebookLogin from "./FacebookLogin";
import GoogleLogin from "./GoogleLogin";
import InstagramLogin from "./InstagramLogin";
import {setCookie} from "../service/cookie";

const Login = props => {
  const [responseMessage, setResponseMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const {executeRecaptcha} = useGoogleReCaptcha();

  const onSubmit = async e => {
    e.preventDefault()
    if (!executeRecaptcha) {
      setResponseMessage('Recaptcha has not been loaded. Please try later.')
      return
    }
    setLoading(true)
    const reCaptchaToken = await executeRecaptcha('submit')
    try {
      const response = await axios.post(appConfig.api_base + 'auth/', {
        "password": e.target.elements.password.value,
        "email": e.target.elements.email.value,
        "g-recaptcha-response": reCaptchaToken
      })
      setCookie('tk', response.data.token)
      setResponseMessage('')
      setLoading(false)
      props.changeLoginStatus()
    } catch (error) {
      window.dispatchEvent(appConfig.showMessage(getErrorMessage(error)));
      setResponseMessage(getErrorMessage(error))
      setLoading(false)
    }
  }

  return (
    <>
      <form className="mtr-form" onSubmit={onSubmit}>
        <h2>Login</h2>
        <div className="mb-3">
          <label htmlFor="email" className="form-label">Email address</label>
          <input type="email" className="form-control" id="email" name="email" required/>
        </div>
        <div className="mb-3">
          <label htmlFor="password" className="form-label">Password</label>
          <input type="password" className="form-control" id="password" name="password" required/>
        </div>
        <button type="submit" className="btn btn-primary" disabled={loading}>
          Submit<Spinner loading={loading}/>
        </button>
        {responseMessage && <div className="text-danger">{responseMessage}</div>}
        <div className="mt-2">
          <Link href="/dashboard/register">Not registered?</Link><br />
          <Link href="/dashboard/lost-password">Forgot password?</Link>
        </div>
      </form>
      <div className="social-btns">
        <h4>Or login with social network</h4>
        <FacebookLogin/>
        <InstagramLogin/>
        <GoogleLogin/>
      </div>
    </>
  )
};

export default Login
